<template>
    <div>
        <h1 class="text-center text-pink mt-5">Admin</h1>
    </div>
</template>

<script>
    export default {
        name: "Admin"
    }
</script>

<style scoped>

</style>